// In src/TabletDetail.js

import React, { useState, useEffect, useRef } from 'react'; // 👈 ADD useRef
import { onSnapshot, query, orderBy, doc, collection, updateDoc, serverTimestamp } from "firebase/firestore";
import { useParams, Link } from 'react-router-dom';
import { db } from './firebase'; // 👈 ADD storage

import { FaPaperPlane, FaCommentDots, FaCommentSlash, FaImage, FaSpinner } from 'react-icons/fa'; // 👈 ADD FaImage & FaSpinner

function TabletDetail() {
  const { tabletId } = useParams();
  const [tablet, setTablet] = useState(null);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [analyticsEvents, setAnalyticsEvents] = useState([]);
  const [analyticsLoading, setAnalyticsLoading] = useState(true);
   const [isChatOpen, setIsChatOpen] = useState(false);
  const [chatCountdown, setChatCountdown] = useState(null); // ✅ ADD THIS LINE
  const [chatHistory, setChatHistory] = useState([]);
const [historyLoading, setHistoryLoading] = useState(true);
 // ✅ ADD THESE TWO LINES
  const [feedback, setFeedback] = useState([]);
  const [feedbackLoading, setFeedbackLoading] = useState(true);
  const getRatingDisplay = (rating) => {
  if (rating <= 4) return { text: 'Unlikely', color: '#e74c3c' }; // Red
  if (rating <= 7) return { text: 'Neutral', color: '#f39c12' }; // Orange
  return { text: 'Likely', color: '#2ecc71' }; // Green
};

  // ✅ NEW: State for the message input
  const [chatMessage, setChatMessage] = useState('');
  const [isSending, setIsSending] = useState(false);
   const [imageFile, setImageFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null); // To help reset the file input

  useEffect(() => {
    const unsubTablet = onSnapshot(doc(db, "tablets", tabletId), (doc) => {
        const tabletData = { id: doc.id, ...doc.data() };
      setTablet(tabletData);
    
    // ✅ NEW: Update our separate chat state from the server data
    setIsChatOpen(tabletData.isChatOpen || false); 
    setChatCountdown(tabletData.chatCountdown || null); 
  });
    const logsRef = collection(db, `tablets/${tabletId}/logs`);
    const qLogs = query(logsRef, orderBy("timestamp", "desc"));
    const unsubLogs = onSnapshot(qLogs, (querySnapshot) => {
      const logsData = [];
      querySnapshot.forEach((doc) => logsData.push({ id: doc.id, ...doc.data() }));
      setLogs(logsData);
      setLoading(false);
    });
    const analyticsRef = collection(db, `tablets/${tabletId}/analytics`);
    const qAnalytics = query(analyticsRef, orderBy("timestamp", "desc"));
    const unsubAnalytics = onSnapshot(qAnalytics, (querySnapshot) => {
      const eventsData = [];
      querySnapshot.forEach((doc) => eventsData.push({ id: doc.id, ...doc.data() }));
      setAnalyticsEvents(eventsData);
      setAnalyticsLoading(false);
    });
     const historyRef = collection(db, `tablets/${tabletId}/chat_history`);
    const qHistory = query(historyRef, orderBy("timestamp", "desc"));
    const unsubHistory = onSnapshot(qHistory, (querySnapshot) => {
        
      const historyData = [];
      querySnapshot.forEach((doc) => {
        historyData.push({ id: doc.id, ...doc.data() });
      });
      setChatHistory(historyData);
      setHistoryLoading(false);
    });
    const feedbackRef = collection(db, `tablets/${tabletId}/feedback`);
const qFeedback = query(feedbackRef, orderBy("timestamp", "desc"));
const unsubFeedback = onSnapshot(qFeedback, (querySnapshot) => {
  const feedbackData = [];
  querySnapshot.forEach((doc) => feedbackData.push({ id: doc.id, ...doc.data() }));
  setFeedback(feedbackData);
  setFeedbackLoading(false);
});

    return () => {
      unsubTablet();
      unsubLogs();
      unsubAnalytics();
      unsubHistory(); // ✅ And add the new unsubscribe function here
      unsubFeedback();
    };
  }, [tabletId]);


const sendCommandToTablet = async (command) => {
  // ✅ MODIFIED: This is now much simpler
  if (command.commandType === 'OPEN_CHAT') {
    setIsChatOpen(true);
  } else if (command.commandType === 'CLOSE_CHAT') {
    setIsChatOpen(false);
  }

  setIsSending(true);
  try {
    const tabletRef = doc(db, "tablets", tabletId);
    await updateDoc(tabletRef, {
      remoteCommand: { ...command, timestamp: serverTimestamp() }
    });
  } catch (error) {
    console.error("Failed to send command:", error);
    alert("Error: Could not send command to tablet.");
    // Revert the state on failure
    if (command.commandType === 'OPEN_CHAT') {
      setIsChatOpen(false);
    } else if (command.commandType === 'CLOSE_CHAT') {
      setIsChatOpen(true);
    }
  } finally {
    setIsSending(false);
  }
};
  const handleSendMessage = (e) => {
    e.preventDefault();
    if (!chatMessage.trim()) return;
    sendCommandToTablet({
      commandType: 'SEND_MESSAGE',
      payload: { text: chatMessage }
    });
    setChatMessage(''); // Clear input after sending
  };
  const handleImageSelect = (e) => {
    if (e.target.files[0]) {
      setImageFile(e.target.files[0]);
    }
  };

const handleSendImage = async () => {
    if (!imageFile) return;
    setIsUploading(true);
    
    const formData = new FormData();
    formData.append('imageFile', imageFile); // 'imageFile' must match the key in the function

    // Replace with your actual Cloud Function URL
    const functionUrl = `https://uploadimagefromadmin-s7dx7q362a-uc.a.run.app?tabletId=${tabletId}`;

    try {
        const response = await fetch(functionUrl, {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Upload failed: ${errorText}`);
        }

        const result = await response.json();
        const downloadURL = result.imageUrl;

        // Now send the command with the URL, just like before
        await sendCommandToTablet({
            commandType: 'SEND_IMAGE',
            payload: { imageUrl: downloadURL }
        });

        setImageFile(null);
        if(fileInputRef.current) fileInputRef.current.value = "";

    } catch (error) {
        console.error("Failed to upload via Cloud Function:", error);
        alert(`Error: ${error.message}`);
    } finally {
        setIsUploading(false);
    }
};

  if (loading) return <p className="loading-text">Loading data for {tabletId}...</p>;

  return (
    <div className="card">
      <Link to="/" className="btn-link">&larr; Back to Dashboard</Link>
      <h2 className="page-header" style={{marginTop: '20px'}}>Status for Tablet: {tabletId}</h2>
      <p className="page-subheader">
        <strong>Last Seen:</strong> {tablet?.lastSeen?.toDate().toLocaleString()} | <strong>Battery:</strong> {tablet?.battery}%
      </p>
<div className="feedback-history-card">
        <h3>Rider Feedback History (NPS)</h3>
        <div className="feedback-history-log">
          {feedbackLoading ? <p>Loading feedback...</p> : feedback.length === 0 ? <p>No feedback submitted yet.</p> : (
            <table className="table">
              <thead>
                <tr>
                  <th>Submitted At</th>
                  <th>Rating</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {feedback.map(fb => {
                  const ratingDisplay = getRatingDisplay(fb.rating);
                  return (
                    <tr key={fb.id}>
                      <td>{fb.timestamp?.toDate().toLocaleString()}</td>
                      <td>{fb.rating} / 10</td>
                      <td style={{ color: ratingDisplay.color, fontWeight: 'bold' }}>
                        {ratingDisplay.text}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>

 <div className="remote-control-card">
  <h3>Remote AI Chat Control</h3>

  {/* --- Row 1: Open/Close Buttons --- */}
  <div className="control-buttons">
    {/* ✅ FIXED: This now uses the optimistic 'isChatOpen' state */}
    {isChatOpen ? (
    <button className="btn btn-approve" disabled>
      <FaCommentDots /> 
     
      {chatCountdown !== null ? `Chat Closing (${chatCountdown})` : 'Chat is Open'}
    </button>
  ) : (
    <button className="btn" onClick={() => sendCommandToTablet({ commandType: 'OPEN_CHAT' })}>
      <FaCommentDots /> Open Chat
    </button>
  )}
    <button 
      className="btn btn-decline" 
      onClick={() => sendCommandToTablet({ commandType: 'CLOSE_CHAT' })} 
      disabled={isSending || !isChatOpen}
    >
      <FaCommentSlash /> Close Chat
    </button>
  </div>

  {/* --- Row 2: Text Message Form --- */}
  <form onSubmit={handleSendMessage} className="message-form">
    <input
      type="text"
      value={chatMessage}
      onChange={(e) => setChatMessage(e.target.value)}
      // ✅ FIXED: This now uses the optimistic 'isChatOpen' state
      placeholder={isChatOpen ? "Type a message to send..." : "Open chat to send messages"}
      disabled={isSending || !isChatOpen}
    />
    <button type="submit" className="btn btn-primary" disabled={isSending || !isChatOpen}>
      <FaPaperPlane /> Send
    </button>
  </form>

  {/* --- Row 3: Image Upload Form --- */}
  <div className="image-upload-form">
    <input
      type="file"
      accept="image/*"
      onChange={handleImageSelect}
      ref={fileInputRef}
      disabled={isUploading || !isChatOpen}
    />
    <button type="button" onClick={handleSendImage} className="btn" disabled={!imageFile || isUploading || !isChatOpen}>
      {isUploading ? <FaSpinner className="animate-spin" /> : <FaImage />} Send Image
    </button>
  </div>
  {imageFile && !isUploading && <p style={{fontSize: '12px', marginTop: '5px'}}>Selected: {imageFile.name}</p>}
</div>
     <div className="chat-history-card">
        <h3>AI Chat History (Last 7 Days)</h3>
        <div className="chat-history-log">
          {historyLoading ? <p>Loading history...</p> : chatHistory.length === 0 ? <p>No chat history found.</p> : (
            chatHistory.map(msg => (
              <div key={msg.id} className={`chat-message ${msg.sender}`}>
                <div className="chat-bubble">
                  <span className="sender-label">{msg.sender}</span>
                  {msg.text && <p>{msg.text}</p>}
                  {msg.imageUrl && <img src={msg.imageUrl} alt="Sent from admin" className="chat-history-image" />}
                  <span className="timestamp">{msg.timestamp?.toDate().toLocaleString()}</span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <h3 style={{marginTop: '30px'}}>Camera Analytics Events</h3>
      <div className="log-view">
        {analyticsLoading ? <p>Loading analytics events...</p> : analyticsEvents.length === 0 ? <p>No camera analytics events recorded yet.</p> : (
          analyticsEvents.map(event => (
            <div key={event.id} className="log-entry">
              <strong>[{event.timestamp?.toDate().toLocaleString()}]</strong>: {event.eventType}
            </div>
          ))
        )}
      </div>

      <h3 style={{marginTop: '30px'}}>Live Activity Log</h3>
      <div className="log-view">
        {logs.map(log => (
          <div key={log.id} className="log-entry">
            <strong className={log.level === 'ERROR' ? 'log-error' : ''}>
              [{log.timestamp?.toDate().toLocaleTimeString()}] [{log.level}]
            </strong>: {log.message}
            {log.errorMessage && <pre className="log-error">{log.errorMessage}</pre>}
          </div>
        ))}
      </div>
    </div>
  );
}

export default TabletDetail;